var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuzuki(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 426 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2 {\r\n        fill: #2e3892;\r\n      }\r\n\r\n      .cls-2, .cls-3 {\r\n        fill-rule: evenodd;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #9d9ea0;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M23.3,0C16.4,6.1,8.6,10.7,.2,14.3l29.9,21.4-1.7,.8-12.4-8.2c-4-2.7-14-.8-16,2.6l23,16.1c6.4-6.1,14.1-11,23.2-14.7L16,11.3l1.6-1.3,9.8,7c4.9,3.5,8.8,4.4,19.3-.8L23.3,0"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "70.1 11.7 83.2 11.7 87.1 25.4 87.1 25.4 91 11.7 104 11.7 104 35.2 95.6 35.2 95.6 18.4 95.5 18.4 90.6 35.2 83.6 35.2 78.6 18.4 78.6 18.4 78.6 35.2 70.1 35.2 70.1 11.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M121,18.8h0l-2.8,8h5.6l-2.8-8m-5.8-7.1h11.4l10,23.5h-9.9l-1-2.7h-9.7l-1,2.7h-9.9l10.1-23.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M168.6,11.7h9.3v14.2c0,3,1.7,4,4.8,4s4.8-1,4.8-4V11.7h9.3v14.6c0,7.5-4.5,9.7-14.1,9.7s-14.1-2.3-14.1-9.7V11.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "207.2 17.6 198.6 17.6 198.6 11.7 225.1 11.7 225.1 17.6 216.5 17.6 216.5 35.2 207.2 35.2 207.2 17.6"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 227,
    y: 11.7,
    width: 9.3,
    height: 23.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M146.9,17.6h6.5c1.5,0,2.7,.4,2.7,2.2,0,1.5-.8,2.2-2.6,2.2h-6.6v-4.4m21.2,17.6l-7.9-7.3c6.5-1,5.7-7.4,5.7-9.6,0-2.6-1.4-4.8-3.2-5.7-1.3-.6-2.9-.9-5.6-.9h-19.5v23.5h9.3v-7.2h1.6l7.8,7.2h11.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M266.5,25.2c-4.5-.7-6.4-3.3-6.4-6.6,0-6.1,6-7.7,13.6-7.7,10.5,0,14.8,2.7,15.1,7.7h-10.8c0-1-.6-1.5-1.4-1.9s-1.9-.5-2.9-.5c-2.8,0-3.7,.7-3.7,1.7,0,.7,.3,1.1,1.2,1.2l11.1,1.6c4.7,.7,7.6,2.9,7.6,6.8,0,5.7-4.7,8.4-15.1,8.4-7.1,0-14.9-1-15-7.9h11.2c0,.8,.3,1.3,1,1.7,.7,.3,1.7,.5,3.2,.5,2.9,0,3.7-.8,3.7-1.9,0-.7-.4-1.4-1.7-1.6l-10.7-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M292.4,11.7h9.3v14.2c0,3,1.7,4,4.8,4s4.8-1,4.8-4V11.7h9.3v14.6c0,7.5-4.5,9.7-14.1,9.7s-14.1-2.3-14.1-9.7V11.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "323 30.2 337.1 17.6 324 17.6 324 11.7 349.6 11.7 349.6 16.8 335.9 29.3 349.3 29.3 349.3 35.2 323 35.2 323 30.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M352.1,11.7h9.3v14.2c0,3,1.7,4,4.8,4s4.8-1,4.8-4V11.7h9.3v14.6c0,7.5-4.5,9.7-14.1,9.7s-14.1-2.3-14.1-9.7V11.7"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 416.7,
    y: 11.7,
    width: 9.3,
    height: 23.5
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "384.3 35.2 393.3 35.2 393.1 26.8 402.2 35.2 414 35.2 401.1 23.2 414.7 11.7 403.4 11.7 393.3 19.8 393.3 11.7 384.3 11.7 384.3 35.2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuzuki);
export default __webpack_public_path__ + "static/media/suzuki.1bfd062938c5687e48ef16913f0640f9.svg";
export { ForwardRef as ReactComponent };